var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.809,
    cy: 8.809,
    r: 5.229,
    stroke: "#212121",
    strokeWidth: 2,
    transform: "rotate(-45 8.809 8.81)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 2,
    d: "m12.773 12.773 5.016 5.017"
  })));
};
export default SvgSearch;